<template>
    <div class="component-centered-TransCAM" :class="{ 'mobile': estMobile }">
        <h1>TransCAM</h1>

        <div class="container-button">

            <label class="container-btn-choix-application" v-on:click="lancerSuiviTiersPayants()">
                <button class="btn-choix-application">
                    <img src="../images/tiers-payant.png" alt="Tiers payants" />
                    Suivi des tiers payants
                </button>
            </label>

            <label class="container-btn-choix-application" v-on:click="lancerLots()">
                <button class="btn-choix-application">
                    <img src="../images/gestion.png" alt="Nom de l'image" />
                    Gestion des feuilles de soins
                </button>
            </label>

            <label class="container-btn-choix-application" v-on:click="lancerEnvois">
                <button class="btn-choix-application">
                    <img src="../images/envois.png" alt="Nom de l'image" />
                    Envois
                </button>
            </label>


            <!--<div class="container-btn-choix-application" v-on:click=""><button class="btn-choix-application"></button></div>-->


        </div>

    </div>
</template>
<style scoped>
    h1 {
        text-align: center;
        color: forestgreen;
        margin-bottom: 15px;
    }

    .container-button {
        display: grid;
        grid-template-columns: auto auto;
        grid-row-gap: 10px;
        grid-column-gap: 10px;
    }

    .component-centered-TransCAM {
        position: absolute; /* postulat de départ */
        top: 50%;
        left: 50%; /* à 50%/50% du parent référent */
        transform: translate(-50%, -50%); /* décalage de 50% de sa propre taille */
    }

    /* En mobile, le contenu dépasse la hauteur de l'écran : on l'aligne en haut
       (et on autorise le défilement) au lieu de le centrer verticalement,
       sinon le haut est coupé. */
    .component-centered-TransCAM.mobile {
        position: static;
        top: auto;
        left: auto;
        transform: none;
        width: fit-content;
        max-width: 100%;
        margin: 20px auto;
    }

    button {
        width: 160px;
        height: 160px;
        border-radius: 10px;
        color: white;
        background-color: cadetblue;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        border: none; /* Pour supprimer la bordure du bouton si nécessaire */
    }

        button:hover {
            background-color: lightgreen;
        }

        button img {
            max-width: 80px; /* Ajustez la taille de l'image selon vos besoins */
            margin-bottom: 10px; /* Ajoute un espacement entre l'image et le texte du bouton */
        }
</style>
<script>
        import { defineComponent } from 'vue';
        import RequestManager from '../script/request.js';

        export default defineComponent({
            data: function () {
                return {
                    message: 'Bienvenu dans la page choix TransCam !'

                }

            },

            computed: {
                estMobile() {
                    return RequestManager.estMobile;
                }
            },

            methods: {
                lancerSuiviTiersPayants() {
                    this.$router.push('/transcam/TiersPayants')
                },
                lancerLots() {
                    this.$router.push('/transcam/Lots');
                },
                lancerEnvois() {
                    this.$router.push('/Envois');
                }
            },

            props: {

            }

        });
</script>
